import _defineProperty from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _extends from "@babel/runtime-corejs3/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from "./BurgerMenu.module.css";
import { DropdownMenuSeparator } from '../DropdownMenu/DropdownMenuSeparator';
import { DropdownMenuLink } from '../DropdownMenu/DropdownMenuLink';
export var BurgerMenuLink = function BurgerMenuLink(_ref) {
  var id = _ref.id,
      hideSeparator = _ref.hideSeparator,
      separatorClassName = _ref.separatorClassName,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["id", "hideSeparator", "separatorClassName", "className"]);

  return React.createElement(React.Fragment, null, !hideSeparator && React.createElement(DropdownMenuSeparator, {
    className: cx(styles.sidebarSeparator, separatorClassName)
  }), React.createElement(DropdownMenuLink, _extends({
    id: id,
    className: cx(styles.sidebarItem, styles.sidebarItemInteractive, className)
  }, props)));
};
BurgerMenuLink.propTypes = _objectSpread({}, DropdownMenuLink.propTypes, {
  id: PropTypes.string.isRequired,
  hideSeparator: PropTypes.bool,
  separatorClassName: PropTypes.string,
  children: PropTypes.node
});
BurgerMenuLink.defaultProps = {
  tag: 'div'
};
BurgerMenuLink.__docgenInfo = {
  componentName: "BurgerMenuLink",
  packageName: "@jutro/router",
  description: "BurgerMenuLink renders single burger menu content element",
  displayName: "BurgerMenuLink",
  methods: [],
  actualName: "BurgerMenuLink",
  props: {
    id: {
      type: {
        name: "string"
      },
      required: true,
      description: "Component unique identifier"
    },
    hideSeparator: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Do not render separator if true"
    },
    separatorClassName: {
      type: {
        name: "string"
      },
      required: false,
      description: "Optional css class to the burger sidebar item separator"
    },
    children: {
      type: {
        name: "node"
      },
      required: false,
      description: "The item's content."
    },
    tag: {
      defaultValue: {
        value: "'div'",
        computed: false
      },
      required: false
    }
  },
  composes: ["../DropdownMenu/DropdownMenuLink"]
};